/**
 * This file takes care of global app side effects,
 * like clicking on add to cart and the cart modal being displayed
 */

import { signal } from '@preact/signals'

export const displayCart = signal(false)
export const displayMenu = signal(false)
const displaySearchPopup = signal(false)
const displaySearchDrawer = signal(false)
const selectingSku = signal(false)
const isFourCollumns = signal(true)
const id = '9147826481267312'

const state = {
    displayCart,
    displayMenu,
    displaySearchPopup,
    displaySearchDrawer,
    selectingSku,
    isFourCollumns,
    id,
}

export const useUI = () => state
